(function($){

/* from productmenu.js */
function stickySubFunction() {
    var top = $('.product-menu').offset().top;
    var scrollTop = $(window).scrollTop();

    if (scrollTop >= top) {
        $('.product-menu').addClass('sticky');
        $('#the-content').css('margin-top', $('.product-menu').outerHeight() + 'px');
    }

    if (top + ($('.product-menu').outerHeight()) < $('#the-content').offset().top) {

        $('.product-menu').removeClass('sticky');
        $('#the-content').css('margin-top', 0);
    }
}

function anchorLink() {

    $('.product-menu li a[href*="#"], a.learn-more[href^="#"]').click(function (event) {
        event.preventDefault();

        var url = $(this).attr("href");
        var hrefTarget = $(this).attr('href');

        var scrollDistance = $(window).scrollTop();
        var menuHeight = $('.product-menu').outerHeight() + 65;

        if ($(this).is('[href*="#product-tab"]')) {
            $('.tab-title').removeClass('active-tab');
            $('.tab-title[data-url="' + hrefTarget + '"]').addClass('active-tab');
            $("[id^='product-tab-'], [id*='product-tab-']").removeClass('open');
            $(hrefTarget).addClass('open');
        }

        $('html, body').animate({
            scrollTop: (($(hrefTarget).offset().top) - menuHeight)
        }, 500);

        if ($('.product-menu-item').hasClass('open')) {
            setTimeout(function () {
                $('.product-menu-mobile-btn').removeClass('active');
                $('.product-menu-item').removeClass('open');
                $('.product-menu-item').slideUp();
            }, 500);
        }

    });
}

function productMenuSlick(){
    $('.vertical-menu>li').insertBefore('.fa-bars');
    window._freeSpace =  $('.product-menu-item')[0].offsetWidth - 80;
    $('.product-menu-item>li').each(function(){
        if( ! $(this).hasClass('fa-bars')) {
            window._freeSpace = window._freeSpace - this.offsetWidth;
            if (window._freeSpace < 0) {
                $(this).detach().appendTo('.vertical-menu'); // console.log('is overflowed (rem:'+ window._freeSpace+')');
            }
        }
    });
    if( $('.vertical-menu>li').length == 0){
        $('.fa-bars').fadeOut();
    }else{
        $('.fa-bars').fadeIn();
    }


}

function openMenuMobile() {
    $('.product-menu-mobile-btn').click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.product-menu-item').removeClass('open');
            $('.product-menu-item').slideUp();
        } else {
            $(this).addClass('active');
            $('.product-menu-item').addClass('open');
            $('.product-menu-item').slideDown();
        }
    });
}
/* from productmenu.js */

/* from productmenu.js */
if ($('.product-menu').length) {

    $(window).scroll(function () {
        var scrollDistance = $(window).scrollTop();
        var menuHeight = $('.product-menu').outerHeight();

        $('.et_pb_section').each(function () {
            var sectionId = $(this).attr('id');
            if (scrollDistance > $(this).offset().top - menuHeight && scrollDistance < $(this).offset().top + $(this).outerHeight() - menuHeight) {
                if (sectionId != undefined) {
                    if ($(this).is("[id*='product-tab-']")) {
                        $('.product-menu li a[href*="#' + sectionId + '"]').parent().addClass('active');
                    }
                }
                //slick go to
                if ($('.product-menu li:not(.slick-cloned) a[href*="#' + sectionId + '"]').length) {
                    var relatedTab = $('.product-menu li:not(.slick-cloned) a[href*="#' + sectionId + '"]').parent().attr('data-num');
                    $('.product-menu-item.slick-slider').slick('slickGoTo', relatedTab);
                } else {
                    var activePage = 0;
                    $('.product-menu-item.slick-slider').slick('slickGoTo', activePage);
                }
                $('.product-menu li a[href*="#' + sectionId + '"]:not([href*="#product-tab"])').parent().addClass('active');
            } else {
                $('.product-menu li a[href*="#' + sectionId + '"]').parent().removeClass('active');
            }
        });
    });

    $(document).scroll(function () {
        stickySubFunction();
    });

    $(document).on('click', '.fa-bars',function () {
        $('ul.vertical-menu').fadeToggle();
    });

    $(document).on('click', 'ul.vertical-menu',function () {
        $(this).fadeOut();
    });

    window.resizeTimer = null;
    $(window).resize(function () {
        clearTimeout(window.resizeTimer);
        window.resizeTimer = setTimeout(function() {
            productMenuSlick();
        }, 250);
    });

    stickySubFunction();
    productMenuSlick();
    //openMenuMobile();
}

if ($('.product-menu li a').length) {
    anchorLink();
}
/* from productmenu.js */

})(jQuery);